
        var result = require("!!../../../../node_modules/css-loader/index.js!./security-authorisation.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-security/security-authorisation.component.css
// module id = 2433
// module chunks = 1